export * from './home/home';
export * from './statistic/statistic';
export * from './address/address';
export * from './block-detail/block-detail';
export * from './blocks/blocks';
export * from './broadcast-tx/broadcast-tx';
export * from './transaction/transaction';
export * from './pages.module';



// WEBPACK FOOTER //
// ./src/pages/index.ts